import { UseQueryResult, useQuery } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getTimezone } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchTimezone(): Promise<APIResult> {
  const response = await fetch(getTimezone, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: Array<{
    Id: number;
    Abbreviation: string;
    TimeZoneInfoId: string;
    DisplayOrder: number;
    UtcOffset: string;
  }>;
};

type TResult = Array<{
  id: number;
  name: string;
}>;

function useGetTimezones(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_timezone',
    async () => {
      const fetchResponse = await fetchTimezone();
      const result = fetchResponse?.Data?.map(item => ({
        id: item.Id,
        name: item.Abbreviation,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetTimezones };
